export default __webpack_public_path__ + "static/media/apple.ab2f5d8e.svg";